module.exports = __webpack_public_path__ + "img/win-install-1.78bce502.svg";